<template>
  <div class="col-xs-12 col-sm-10 rs-account-contain-sty row">
    <div class="col-md-12" style="height: 100vh;display: flex;justify-content: center;align-items: center;" v-if="isLoad">
        <b-spinner style="width: 10em; height: 10rem;" label="Large Spinner" type="grow"></b-spinner>
      </div>
    <div class="col-xs-12 col-sm-10" v-else>
      <div class="order-title-area-sty">
        <div class="order-main-title-sty">
          <h5>
            <span>
              訂單編號 <b>#{{orderData.id}}</b>
            </span>
            <span style="margin-left:25px;">
              <b>{{ orderData.service_type }}</b>
            </span>
          </h5>
        </div>
        <hr>
        <div class="row">
          <div class="col-sm-4 order-info-label-sty">服務時間</div>
          <div class="col-sm-8">
            <span class="list-order-date-sty">{{orderData.roc_date}} ( {{orderData.diplayWeekDay}} )</span>
            <span class="list-order-time-sty">{{orderData.time_desc }}</span>
          </div>
        </div>
        <div class="order-info-status-sty">
          <div class="order-info-label-sty">訂單狀態</div>
          <div>
            <span :class="`${ orderData.statusClass }`"> {{ orderData.status }} </span>
          </div>
        </div>
        <div class="row order-info-group-sty" v-if="orderData.staffs">
          <div class="col-sm-4 order-info-label-sty">服務夥伴</div>
          <div class="col-sm-8">
            <div v-for="(staff, index) in orderData.staffs" :key="index">
              <b> {{staff.displayN}}</b>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="order-contain">
        <div class="">
          <div class="order-sub-title-sty">
            <h5 v-if="userType === 'customer'">個人資料</h5>
            <h5 v-else>服務對象資料</h5>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">姓名</div>
            <div class="col-sm-8">{{ orderData.name }}</div>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">手機</div>
            <div class="col-sm-8">{{ orderData.phone }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.alternate_phone && orderData.alternate_phone.length > 0">
            <div class="col-sm-4 order-info-label-sty">備用電話</div>
            <div class="col-sm-8">{{ orderData.alternate_phone }}</div>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">地址<span @click="copyAddress" class="rs-icon-btn-sty rs-icon-color-ligtorange"><i class="rs-icon-default rs-icon-address"></i></span></div>
            <div class="col-sm-8">{{ orderData.dsLocation }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.contactDsTime && orderData.contactDsTime.length > 0">
            <div class="col-sm-12 order-info-label-sty">客戶方便接聽電話的時段</div>
            <div class="col-sm-12"  v-for="(time, index) in orderData.contactDsTime" :key="index">
              <div>
                時段{{ index + 1 }}: <b style="color: #6086ed;">{{ time }}</b>
              </div>
            </div>
          </div>
          <div class="order-sub-title-sty">
            <h5>清潔相關資訊</h5>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">服務類型</div>
            <div class="col-sm-8">{{ orderData.service_type }}</div>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">清潔建築類型</div>
            <div class="col-sm-8">{{ orderData.building_type }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.cleaning_range && orderData.cleaning_range.length > 0">
            <div class="col-sm-4 order-info-label-sty">清潔範圍</div>
            <div class="col-sm-8 rc-html-sty">{{ orderData.cleaning_range }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.building_square && orderData.building_square.length > 0">
            <div class="col-sm-4 order-info-label-sty">清潔範圍大小</div>
            <div class="col-sm-8">{{ orderData.building_square }}</div>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">服務員性別指定</div>
            <div class="col-sm-8">{{ orderData.gender }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.has_pet || orderData.spec_clenaer || orderData.spec_glue_rm">
            <div class="col-sm-12 order-info-label-sty">清潔注意項目</div>
            <div class="col-sm-4" v-if="orderData.has_pet">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">有寵物</span>
            </div>
            <div class="col-sm-4" v-if="orderData.spec_clenaer">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">自備吸塵器</span>
            </div>
            <div class="col-sm-4" v-if="orderData.spec_glue_rm">
              <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
              <span class="textafterimg-sty">除膠</span>
            </div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.note && orderData.note.length > 0">
            <div class="col-sm-12 order-info-label-sty">訂單注意事項</div>
            <div class="col-sm-12">{{ orderData.note }}</div>
          </div>
        </div>
        <div>
          <hr>
          <div>
            <div class="order-sub-title-sty">
              <h5>環境空間確認</h5>
            </div>
            <div class="row order-info-group-sty">
              <div class="col-sm-12 order-info-label-sty">需要清掃房間</div>
              <div class="col-sm-12" v-if="!houseCheckInfo.kitchen && !houseCheckInfo.living_room && !houseCheckInfo.bedroom && !houseCheckInfo.bathroom && !houseCheckInfo.balcony && !houseCheckInfo.entrance">
                <span>未確認環境空間</span>
              </div>
              <div class="col-sm-4" v-if="houseCheckInfo.kitchen">
                <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
                <span class="textafterimg-sty">廚房</span>
              </div>
              <div class="col-sm-4" v-if="houseCheckInfo.living_room">
                <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
                <span class="textafterimg-sty">客廳</span>
              </div>
              <div class="col-sm-4" v-if="houseCheckInfo.bedroom">
                <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
                <span class="textafterimg-sty">臥室</span>
              </div>
              <div class="col-sm-4" v-if="houseCheckInfo.bathroom">
                <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
                <span class="textafterimg-sty">浴室</span>
              </div>
              <div class="col-sm-4" v-if="houseCheckInfo.balcony">
                <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
                <span class="textafterimg-sty">陽台</span>
              </div>
              <div class="col-sm-4" v-if="houseCheckInfo.entrance">
                <img alt="checkmark" src="@/assets/img/correct.png" class="checkmark-img-sty">
                <span class="textafterimg-sty">玄關</span>
              </div>
            </div>
            <div class="row order-info-group-sty" v-if="houseCheckInfo.note && houseCheckInfo.note.length > 0">
              <div class="col-sm-12 order-info-label-sty">環境注意事項</div>
              <div class="col-sm-12 rc-html-sty">{{ houseCheckInfo.note }}</div>
            </div>
          </div>
        </div>
        <hr>
        <div>
          <div class="order-sub-title-sty">
            <h5>方案資訊</h5>
          </div>
          <div class="row order-info-group-sty" v-if="houseCheckInfo.userTypeStr">
            <div class="col-sm-4 order-info-label-sty">類型</div>
            <div class="col-sm-8">{{ houseCheckInfo.userTypeStr }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="houseCheckInfo.orderTypeStr">
            <div class="col-sm-4 order-info-label-sty">特殊方案</div>
            <div class="col-sm-8">{{ houseCheckInfo.orderTypeStr }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.coupon_code_cost && orderData.coupon_code">
            <div class="col-sm-4 order-info-label-sty">折扣碼</div>
            <div class="col-sm-8">{{ orderData.coupon_code }}</div>
            <div class="col-sm-4 order-info-label-sty">折扣金額</div>
            <div class="col-sm-8 order-status-warn">{{ orderData.coupon_code_cost }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.specified_cash">
            <div class="col-sm-4 order-info-label-sty">預算上限金額</div>
            <div class="col-sm-8">{{ orderData.specified_cash }} 元</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.specified_max_cash_time">
            <div class="col-sm-4 order-info-label-sty">預算上限時數</div>
            <div class="col-sm-8">{{ orderData.specified_max_cash_time }} 小時</div>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">付款方式</div>
            <div class="col-sm-8">{{ orderData.payment }}</div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.transfer_code">
            <div class="col-sm-4 order-info-label-sty">付款帳號後五碼</div>
            <div class="col-sm-8">{{ orderData.transfer_code }}</div>
          </div>
        </div>
        <div v-if="orderData.cost_time || orderData.coupon_code || orderData.coupon_code_cost || orderData.cash">
          <div class="order-sub-title-sty">
            <h5>當前花費時間與金額</h5>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.cost_time">
            <div class="col-sm-4 order-info-label-sty">花費時間</div>
            <div class="col-sm-8">
              <span>{{ orderData.cost_time }}</span>
            </div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.coupon_code">
            <div class="col-sm-4 order-info-label-sty">使用折扣碼</div>
            <div class="col-sm-8">
              <span>{{ orderData.coupon_code }}</span>
            </div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.coupon_code_cost">
            <div class="col-sm-4 order-info-label-sty">折扣金額</div>
            <div class="col-sm-8">
              <span>{{ orderData.coupon_code_cost }}</span>
            </div>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">目前金額</div>
            <div class="col-sm-8">
              <span>{{ orderData.cash }}</span>
            </div>
          </div>
        </div>
        <div v-if="orderData.score_item_infos && orderData.score_item_infos.length > 0">
          <div class="order-sub-title-sty">
            <h5>訂單評分</h5>
          </div>
          <div v-for="(scoption, index) in orderData.score_item_infos" :key="index">
            <div class="row order-info-group-sty">
              <div class="col-sm-4 order-info-label-sty">{{ scoption.label }}</div>
              <div class="col-sm-8">
                <b-form-rating :id="'score_val_' + index" v-model="scoption.score" inline readonly no-border size="md" class="re-order-input-sty"></b-form-rating>
              </div>
              <div class="col-sm-12" v-if="scoption.feedback">{{ scoption.feedback }}</div>
            </div>
          </div>
          <div class="row order-info-group-sty">
            <div class="col-sm-4 order-info-label-sty">平均分數</div>
            <div class="col-sm-8">
              <span>{{ orderData.score }}</span>
            </div>
          </div>
          <div class="row order-info-group-sty" v-if="orderData.score_feedback">
            <div class="col-sm-4 order-info-label-sty">用戶回饋</div>
            <div class="col-sm-8 rc-html-sty">
              <span>{{ orderData.score_feedback }}</span>
            </div>
          </div>
        </div>
        <hr>
        <div class="order-footer-contain text-left">
          <b-button
              class="text-white order-info-btn-sty "
              variant="info"
              size="md"
              @click="backToLastPath"
              >返回
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AccountOrderWarp',
  props: {
    lineId: String, // line user id
    userType: String
  },
  data () {
    return {
      accountType: '',
      orderInfo: {},
      orderData: {},
      houseCheckInfo: {},
      isIncludeStaff: false,
      isLoad: false
    }
  },
  created () {
    this.$nextTick(() => {
      this.getCurrentInfo()
    })
  },
  watch: {
    orderData (data) {
      if (data && data.base_house_work_list_info) {
        this.houseCheckInfo = data.base_house_work_list_info
      }
    },
    houseCheckInfo (data) {
      if (data.user_type) {
        this.orderData.userTypeStr = this.$toolDoc.convertOrderUserType(data.user_type)
      }
      if (data.order_type) {
        this.orderData.orderTypeStr = this.$toolDoc.convertOrderUserType(data.order_type)
      }
    }
  },
  methods: {
    getCurrentInfo () {
      const routeInfo = this.$store.getters.getRouteInfo
      var infoStr
      var orderData = this.$store.getters.getAccountOrderData
      if (routeInfo) {
        this.accountType = routeInfo.case
        infoStr = this.$tool.decodeString(routeInfo.id)
        this.orderInfo = JSON.parse(infoStr)
        if (orderData && orderData.id === this.orderInfo.order && orderData.user_id === this.orderInfo.user) {
          this.orderData = orderData
          console.log(this.orderData)
        } else {
          this.getAccountOrder()
        }
        this.$parent.isLoadShow = false
      } else {
        this.backToLastPath()
      }
    },
    getAccountOrder () {
      const self = this
      const baseUrl = this.userType !== 'staff' ? this.$apiDoc.customerUrl : this.$apiDoc.staffUrl
      const getUrl = baseUrl + this.lineId + this.$apiDoc.apiGetOrderDash
      var options = {
        page: 1,
        per: 1,
        name_id_like: this.orderInfo.order,
        user_id: this.orderInfo.user
      }
      var orderArray = []
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var logMsg
      var isError = true
      this.isLoad = true
      this.$api.get(getUrl, options).then((resp) => {
        if (resp.result) {
          if (resp.data.order_infos && Array.isArray(resp.data.order_infos)) {
            orderArray = self.arrangeOrderData(resp.data.order_infos)
          }
          if (orderArray.length > 0) {
            self.orderData = orderArray[0]
            console.log('orderData', self.orderData)
            if (self.orderData !== null && self.orderData !== undefined) {
              isError = false
            }
          }
        }
        if (isError) {
          if (resp.data) {
            errorMsg = resp.data
          }
          self.$bvToast.toast(errorMsg, {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        }
        self.isLoad = false
      }).catch((errorInfo) => {
        logMsg = errorInfo
        console.warn(logMsg)
        self.$bvToast.toast(errorMsg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
        self.isLoad = false
      })
    },
    arrangeOrderData (array) {
      const self = this
      array.forEach((item) => {
        item = self.$toolDoc.arrangeOrderData(item)
      })
      return array
    },
    copyAddress () {
      const self = this
      if (this.orderData && this.orderData.dsLocation) {
        navigator.clipboard.writeText(this.orderData.dsLocation).then(() => {
          self.$bvToast.toast('成功複製地址', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'success',
            solid: true
          })
        })
      }
    },
    backToLastPath () {
      this.$router.go(-1)
    }
  }
}
</script>
